import axios from "axios";

export const USER_URL = "/User";
export const USER_AUTHORITY_URL = "/UserAuthority";

// Kullanıcı Türü, Modül ve Yetki Listesini Elde Eder
export function getList() {
  return axios.get(USER_AUTHORITY_URL);
}

// Mevcut Okulun Belli Bir Kullanıcı Türüne Ait Aktif Kullanıcı Listesini Elde Eder
export function getUsers(userType) {
  return axios.get(`${USER_URL}/GetUsers/${userType}`);
}

// Belli Bir Kullanıcının Yetkilerini Elde Eder
export function getAuthorities(userType, userId) {
  return axios.get(`${USER_AUTHORITY_URL}/${userType}/${userId}`);
}

// Belli Bir Kullanıcının Yetkilerini Kaydeder
export function saveAuthorities(userId, userType, moduleAndAuthorities) {
  return axios.post(USER_AUTHORITY_URL, { userId, userType, moduleAndAuthorities });
}